import { imageMediaTypes } from '@synergy/models';

export const isMimeTypeImage = (mimeType: string): boolean => {
    return Object.keys(imageMediaTypes).includes(mimeType);
};
